import tokens from '@kluein/design-tokens';
import { Box } from '@kluein/klue-ui';
import { Suspense, type ReactNode } from 'react';

import { AppNavBar } from 'components/layout/app-nav-bar';
import { AppSideAction } from 'components/layout/app-side-action';
import { OfflineBanner } from 'components/layout/offline-banner';
import { PreviewBanner } from 'components/layout/preview-banner';
import { SubmitIntel } from 'components/layout/submit-intel';
import TEST_IDS from 'test-ids';

type MainLayoutPropTypes = {
  children: ReactNode;
};

export default function MainLayout({ children }: MainLayoutPropTypes) {
  return (
    <Box fill>
      <OfflineBanner />
      <PreviewBanner />
      <AppNavBar />
      <Box
        direction="row"
        fill
        overflow="hidden"
        data-test-id={TEST_IDS.layout.mainLayout.container}
        style={{ isolation: 'isolate' }}
      >
        <SubmitIntel />
        <MainLayoutContent>{children}</MainLayoutContent>
        <AppSideAction />
      </Box>
    </Box>
  );
}

export function MainLayoutContent({ children }: MainLayoutPropTypes) {
  return (
    <Box
      background={tokens.color.neutral.rosegrey.main}
      fill
      data-test-id={TEST_IDS.layout.mainLayout.content}
      role="main"
    >
      <Suspense fallback={<div />}>{children}</Suspense>
    </Box>
  );
}
